import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import BasicButton from '../../components/buttons/basicButton';
import Page from '../../components/display/layout/pageBasic';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';
import routes from '../../constants/routes';

import useRoleFlags from '../../hooks/auth/useRoleFlags';
import useGetLocationState from '../../hooks/helper/useGetLocationState';

import DashboardCards from './DashboardCards';

const HomeDashboardV2: FC<React.PropsWithChildren<unknown>> = () => {
    const history = useHistory();

    const { hasCreateFormulaAccess } = useRoleFlags();

    const { getLocationState } = useGetLocationState('Back to Dashboard');

    const handleNewMessage = () => {
        history.push(routes.formulasCreate, getLocationState());
    };

    return (
        <Page
            disableBreadcrumbs
            title={'Dashboard'}
            style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: aampeTheme.spacing4(4),
                flex: 1,
                minHeight: 0,
            }}
            childClass="hide-scroll-bar"
            childStyle={{ flex: 1, minHeight: 0, overflow: 'auto' }}
            actionBar={
                <Header>
                    {hasCreateFormulaAccess && (
                        <Content>
                            <BasicButton
                                name="New message"
                                icon={<ICONS.plus />}
                                isPrimary
                                style={{
                                    border: 'none',
                                }}
                                action={handleNewMessage}
                            />
                        </Content>
                    )}
                </Header>
            }
        >
            <DashboardCards />
        </Page>
    );
};

const Header = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
    justifyContent: 'space-between',
}));

const Content = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing(2),
}));

export default HomeDashboardV2;
